<template>
    <div class="container">
        <div class="card">
            <div class="card-row">
                <h3 style="font-size: 16px;margin: 0;">日常打卡</h3>
                <div class="small accent" style="white-space: nowrap;">
                    今日已打卡: <strong>{{ todaysCount }}</strong>
                </div>
            </div>

            <div style="margin-top:12px">
                <div class="muted small" style="margin-bottom:6px">
                    请上传与品牌相关的图片并填写简短说明（1-9 张）
                </div>
                <textarea v-model="note" class="input textarea" placeholder="补充说明（可选）"></textarea>
            </div>

            <div style="margin-top:12px">
                <ImageUploader v-model="images" :maxFiles="6" />
            </div>

            <div style="display:flex;gap:8px;justify-content:space-between;align-items:center;margin-top:12px;">
                <div class="tips small" style="white-space: pre-wrap">
                    * 请确保图片清晰，避免上传过大文件。
                </div>
                <button class="button" :disabled="submitting || images.length === 0" @click="submit">
                    <span v-if="submitting">提交中…</span>
                    <span v-else>提交打卡</span>
                </button>
            </div>
        </div>

        <!-- 历史记录 -->
        <div v-if="history.length" class="card">
            <div style="display:flex;justify-content:space-between;align-items:center">
                <div style="font-weight:500">我的打卡记录</div>
                <div class="muted small">最近 30 天内</div>
            </div>

            <div style="margin-top:12px">
                <div v-for="item in history" :key="item.id" style="margin-top:10px" class="card-row">
                    <div style="display:flex;gap:10px;align-items:center">
                        <div style="width:56px;height:56px;border-radius:8px;overflow:hidden;background:#f6fbff">
                            <img v-if="item.image_urls && item.image_urls.length" :src="item.image_urls[0]"
                                style="width:100%;height:100%;object-fit:cover" />
                        </div>
                        <div style="height: 56px;
                                    width: calc(100% - 66px);
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;">
                            <div style="font-weight:500;width: 90%;" class="two-line-ellipsis">{{ item.note || "" }}
                            </div>
                            <div class="muted small">{{ formatTime(item.created_at) }}</div>
                        </div>
                    </div>

                    <!-- <div class="small primary" style="color: var(--accent);" @click="toDetail(item.id)">
                        查看
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageUploader from "../components/ImageUploader.vue";
import { toast } from "@/util/toast"
import { submitCheckin, getMyCheckins } from '../api/checkin'

export default {
    name: "CheckinPage",
    components: { ImageUploader },

    data() {
        return {
            images: [],
            note: "",
            submitting: false,
            history: [],
            todaysCount: 0,
        };
    },

    created() {
        this.loadHistory();
    },
    methods: {
        formatTime(iso) {
            try {
                return new Date(iso).toLocaleString();
            } catch (e) {
                return iso;
            }
        },

        async loadHistory() {
            try {
                const records = await getMyCheckins();
                this.history = records;
                // 统计今天次数
                const today = new Date().toISOString().slice(0, 10);
                this.todaysCount = this.history.filter((h) => {
                    return (h.created_at || "").slice(0, 10) === today;
                }).length;
            } catch (err) {
                console.error(err);
                toast(err.message || "获取打卡记录失败");
            }
        },
        async submit() {
            if (this.submitting) return;

            if (this.images.length === 0) {
                toast("请至少上传一张图片");
                return;
            }

            this.submitting = true;

            try {
                const payload = {
                    image_urls: this.images,
                    note: this.note,
                };
                console.log("submitCheckin", payload);
                await submitCheckin(payload);
                toast("提交成功");
                // 清空数据
                this.images = [];
                this.note = "";

                await this.loadHistory();
            } catch (err) {
                console.error(err);
                toast("提交失败，请重试");
            } finally {
                this.submitting = false;
            }
        },
        toDetail(id) {
            this.$router.push({ name: 'checkInDetail', params: { id } })
        }
    },
};
</script>
<style scoped>
.container {
    padding: 16px;
    min-height: calc(100vh - 32px);
    background: linear-gradient(90deg, rgba(150, 226, 251, 0.2) 0%, rgba(183, 171, 236, 0.2) 100%);
}

/* Card */
.card {
    background: var(--card);
    border-radius: var(--radius-lg);
    padding: 14px;
    margin-bottom: 12px;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    -webkit-border-radius: var(--radius-lg);
    -moz-border-radius: var(--radius-lg);
    -ms-border-radius: var(--radius-lg);
    -o-border-radius: var(--radius-lg);
}

.card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Buttons */
.button {
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background: var(--primary);
    color: #fff;
    border: 0;
    cursor: pointer;
    box-shadow: var(--shadow-xs);
    font-weight: 500;
    white-space: nowrap;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
}

a {
    text-decoration: none;
    color: #fff;
}

.ghost {
    background: transparent;
    color: var(--accent);
    border: 1px solid rgba(0, 160, 255, 0.12);
}

/* Input */
.input {
    font-size: 14px;
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #edf2f7;
    background: #fbfdff;
    box-sizing: border-box;
}

.textarea {
    min-height: 96px;
    resize: vertical;
}

/* Image grid */
.img-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.img-grid img {
    width: 100%;
    height: auto;
}

.img-grid .thumb {
    width: calc(33.333% - 8px);
    aspect-ratio: 1/1;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    background: linear-gradient(180deg, #f8fbff, #eef7ff);
}

.img-grid .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* thumb overlay (delete button) */
.thumb .delete {
    position: absolute;
    right: 6px;
    top: 6px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 999px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
}

/* Skeleton */
.skeleton {
    background: linear-gradient(90deg, #f0f0f0, #f7f7f7, #f0f0f0);
    background-size: 200% 100%;
    animation: shimmer 1.2s linear infinite;
    border-radius: 8px;
}

.tips {
    color: var(--tips);
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* Tiny UI */
.row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.muted {
    color: var(--muted);
    font-size: 13px;
}

.small {
    font-size: 12px;
    white-space: nowrap;
}

/* 两行省略 - 最常用 */
.two-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 控制显示的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>
